// Exported sample data constants
import {StateModel} from '../../models/state.model';
import {PostcodeModel} from '../../models/postcode.model';
import {CountryModel} from '../../models/country.model';
import {MccCodeModel} from '../../models/mcc-code.model';
import {PhoneCountryModel} from '../../models/phone-country.model';
import {BankModel} from '../../models/bank.model';
import {MseModel} from '../../models/mse.model';

export const mccCodeSample: MccCodeModel[] = [
  {
    id: 1,
    code: '742',
    name: 'VETERINARY SERVICES',
    display_name: 'VETERINARY SERVICES',
    description: null,
    is_prohibited: false,
    is_high_risk: false,
    is_enabled: true
  },
  {
    id: 2,
    code: '743',
    name: 'WINE PRODUCERS',
    display_name: 'WINE PRODUCERS',
    description: null,
    is_prohibited: false,
    is_high_risk: false,
    is_enabled: true
  },
  {
    id: 3,
    code: '744',
    name: 'CHAMPAGNE PRODUCERS',
    display_name: 'CHAMPAGNE PRODUCERS',
    description: null,
    is_prohibited: false,
    is_high_risk: false,
    is_enabled: true
  },
  {
    id: 4,
    code: '1002',
    name: 'WHOLESALE',
    display_name: 'WHOLESALE',
    description: null,
    is_prohibited: false,
    is_high_risk: false,
    is_enabled: true
  },
];

export const countrySample: CountryModel[] = [
  {id: 132, name: 'Malaysia', iso2: 'MY', phone_code: '60', native: 'Malaysia', is_enabled: true},
  {id: 174, name: 'Thailand', iso2: 'TH', phone_code: '66', native: 'ประเทศไทย', is_enabled: true},
  {id: 219, name: 'Philippines', iso2: 'PH', phone_code: '63', native: 'Pilipinas', is_enabled: true},
];

export const stateSample: StateModel[] = [
  {id: 1949, name: 'Kuala Lumpur', country_id: 132, native: 'Kuala Lumpur', is_enabled: true},
];

export const postcodeSample: PostcodeModel[] = [
  {
    id: 1,
    country_id: 132,
    state_id: 1949,
    country_iso2: 'MY',
    postal_code: '51200',
    city: 'Kuala Lumpur',
    state: 'Kuala Lumpur',
    is_enabled: true
  },
];

export const phoneCountrySample: PhoneCountryModel[] = [
  {id: 1, country_id: 132, display_name: 'Malaysia', phone_code: '60', is_enabled: true},
  {id: 3, country_id: 174, display_name: 'Thailand', phone_code: '66', is_enabled: true},
  {id: 5, country_id: 219, display_name: 'Philippines', phone_code: '63', is_enabled: true},
];

export const tokenRequestSample = {
  grant_type: '',
  client_id: '',
  client_secret: '',
}

export const dropdownQuerySample = {
  types: [],
}

export const tokenSample = {
  token: '123',
}

export const bankListSample: BankModel[] = [
  // Domestic
  { id: 10, name: 'affin_bank', display_name: 'Affin Bank', group: 'Domestic Banks', capture_bank_id: 10, is_enabled: true },
  { id: 11, name: 'alliance_bank', display_name: 'Alliance Bank', group: 'Domestic Banks', capture_bank_id: 11, is_enabled: true },
  { id: 12, name: 'ambank', display_name: 'AmBank', group: 'Domestic Banks', capture_bank_id: 12, is_enabled: true },
  { id: 13, name: 'cimb_bank', display_name: 'CIMB Bank', group: 'Domestic Banks', capture_bank_id: 13, is_enabled: true },
  { id: 14, name: 'hong_leong_bank', display_name: 'Hong Leong Bank', group: 'Domestic Banks', capture_bank_id: 14, is_enabled: true },
  { id: 15, name: 'maybank', display_name: 'Maybank', group: 'Domestic Banks', capture_bank_id: 15, is_enabled: true },
  { id: 16, name: 'public_bank', display_name: 'Public Bank', group: 'Domestic Banks', capture_bank_id: 16, is_enabled: true },
  { id: 17, name: 'rhb_bank', display_name: 'RHB Bank', group: 'Domestic Banks', capture_bank_id: 17, is_enabled: true },

  // Foreign
  { id: 18, name: 'american_express_bank', display_name: 'American Express Bank', group: 'Foreign Banks', capture_bank_id: 18, is_enabled: true },
  { id: 19, name: 'bnp_paribas_malaysia', display_name: 'BNP Paribas Malaysia', group: 'Foreign Banks', capture_bank_id: 19, is_enabled: true },
  { id: 20, name: 'bangkok_bank', display_name: 'Bangkok Bank', group: 'Foreign Banks', capture_bank_id: 20, is_enabled: true },
  { id: 21, name: 'bank_of_america_malaysia', display_name: 'Bank of America Malaysia', group: 'Foreign Banks', capture_bank_id: 21, is_enabled: true },
  { id: 22, name: 'bank_of_china_malaysia', display_name: 'Bank of China Malaysia', group: 'Foreign Banks', capture_bank_id: 22, is_enabled: true },
  { id: 23, name: 'mufg_bank', display_name: 'MUFG Bank (Bank of Tokyo-Mitsubishi UFJ)', group: 'Foreign Banks', capture_bank_id: 23, is_enabled: true },
  { id: 24, name: 'china_construction_bank_malaysia', display_name: 'China Construction Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 24, is_enabled: true },
  { id: 25, name: 'citibank_malaysia', display_name: 'Citibank Malaysia (Now UOB Malaysia)', group: 'Foreign Banks', capture_bank_id: 25, is_enabled: true },
  { id: 26, name: 'deutsche_bank_malaysia', display_name: 'Deutsche Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 26, is_enabled: true },
  { id: 27, name: 'hsbc_malaysia', display_name: 'HSBC Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 27, is_enabled: true },
  { id: 28, name: 'india_international_bank', display_name: 'India International Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 28, is_enabled: true },
  { id: 29, name: 'icbc_malaysia', display_name: 'ICBC Malaysia', group: 'Foreign Banks', capture_bank_id: 29, is_enabled: true },
  { id: 30, name: 'jpmorgan_chase_malaysia', display_name: 'J.P. Morgan Chase Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 30, is_enabled: true },
  { id: 31, name: 'mizuho_bank_malaysia', display_name: 'Mizuho Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 31, is_enabled: true },
  { id: 32, name: 'ocbc_bank_malaysia', display_name: 'OCBC Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 32, is_enabled: true },
  { id: 33, name: 'standard_chartered_malaysia', display_name: 'Standard Chartered Bank Malaysia', group: 'Foreign Banks', capture_bank_id: 33, is_enabled: true },
  { id: 34, name: 'smbc_malaysia', display_name: 'Sumitomo Mitsui Banking Corporation Malaysia', group: 'Foreign Banks', capture_bank_id: 34, is_enabled: true },
  { id: 35, name: 'nova_scotia_bank', display_name: 'The Bank of Nova Scotia', group: 'Foreign Banks', capture_bank_id: 35, is_enabled: true },
  { id: 36, name: 'uob_malaysia', display_name: 'United Overseas Bank (UOB) Malaysia', group: 'Foreign Banks', capture_bank_id: 36, is_enabled: true },

  // Islamic
  { id: 37, name: 'affin_islamic', display_name: 'Affin Islamic Bank', group: 'Islamic Banks', capture_bank_id: 37, is_enabled: true },
  { id: 38, name: 'al_rajhi', display_name: 'Al Rajhi Bank', group: 'Islamic Banks', capture_bank_id: 38, is_enabled: true },
  { id: 39, name: 'alkhair_islamic', display_name: 'Alkhair International Islamic Bank', group: 'Islamic Banks', capture_bank_id: 39, is_enabled: true },
  { id: 40, name: 'alliance_islamic', display_name: 'Alliance Islamic Bank', group: 'Islamic Banks', capture_bank_id: 40, is_enabled: true },
  { id: 41, name: 'ambank_islamic', display_name: 'AmBank Islamic', group: 'Islamic Banks', capture_bank_id: 41, is_enabled: true },
  { id: 42, name: 'mbsb_bank', display_name: 'MBSB Bank', group: 'Islamic Banks', capture_bank_id: 42, is_enabled: true },
  { id: 43, name: 'bank_islam', display_name: 'Bank Islam Malaysia', group: 'Islamic Banks', capture_bank_id: 43, is_enabled: true },
  { id: 44, name: 'bank_muamalat', display_name: 'Bank Muamalat Malaysia', group: 'Islamic Banks', capture_bank_id: 44, is_enabled: true },
  { id: 45, name: 'cimb_islamic', display_name: 'CIMB Islamic Bank', group: 'Islamic Banks', capture_bank_id: 45, is_enabled: true },
  { id: 46, name: 'hong_leong_islamic', display_name: 'Hong Leong Islamic Bank', group: 'Islamic Banks', capture_bank_id: 46, is_enabled: true },
  { id: 47, name: 'hsbc_amanah', display_name: 'HSBC Amanah Malaysia', group: 'Islamic Banks', capture_bank_id: 47, is_enabled: true },
  { id: 48, name: 'kuwait_finance_house', display_name: 'Kuwait Finance House Malaysia', group: 'Islamic Banks', capture_bank_id: 48, is_enabled: true },
  { id: 49, name: 'maybank_islamic', display_name: 'Maybank Islamic', group: 'Islamic Banks', capture_bank_id: 49, is_enabled: true },
  { id: 50, name: 'ocbc_al_amin', display_name: 'OCBC Al-Amin', group: 'Islamic Banks', capture_bank_id: 50, is_enabled: true },
  { id: 51, name: 'public_islamic', display_name: 'Public Islamic Bank', group: 'Islamic Banks', capture_bank_id: 51, is_enabled: true },
  { id: 52, name: 'rhb_islamic', display_name: 'RHB Islamic Bank', group: 'Islamic Banks', capture_bank_id: 52, is_enabled: true },
  { id: 53, name: 'standard_chartered_saadiq', display_name: 'Standard Chartered Saadiq', group: 'Islamic Banks', capture_bank_id: 53, is_enabled: true },

  // Digital
  { id: 54, name: 'gx_bank', display_name: 'GX Bank', group: 'Digital Banks', capture_bank_id: 54, is_enabled: true },
  { id: 55, name: 'boost_bank', display_name: 'Boost Bank', group: 'Digital Banks', capture_bank_id: 55, is_enabled: true },
  { id: 56, name: 'aeon_bank', display_name: 'AEON Bank (Islamic Digital Bank)', group: 'Digital Banks', capture_bank_id: 56, is_enabled: true }
];

export const bankTypeList = [
  {value: 'savings', label: 'Savings' },
  {value: 'current', label: 'Current' },
];

export const businessModelList = [
  {value: 'b2c', label: 'B2C: Single Signatory' },
  {value: 'b2b', label: 'B2B: Single Signatory' },
];

export const mseSample: MseModel[] = [
  { id: 1, client_id: 1, first_name: 'Kin Chen, Daniel', last_name: 'Cheang', display_name: 'Cheang Kin Chen, Daniel', user_id: 101, capture_username: 'mse0219', is_enabled: true },
  { id: 2, client_id: 1, first_name: 'MD FARHAT', last_name: 'MD NAJJIB', display_name: 'MD NAJJIB MD FARHAT', user_id: 102, capture_username: 'ftm1601', is_enabled: true },
  { id: 3, client_id: 1, first_name: 'Wei Liang', last_name: 'Tan', display_name: 'Tan Wei Liang', user_id: 103, capture_username: 'mse0301', is_enabled: true },
  { id: 4, client_id: 1, first_name: 'Amirul', last_name: 'Hakim', display_name: 'Hakim Amirul', user_id: 104, capture_username: 'mse0415', is_enabled: true },
  { id: 5, client_id: 2, first_name: 'Siew Mei', last_name: 'Lim', display_name: 'Lim Siew Mei', user_id: 105, capture_username: 'cd0112', is_enabled: true },
];
